window.KSWishlist = (function () {
  const KEY = 'ks_wishlist_v1';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('ks:wishlist:update', { detail: items }));
      return true;
    } catch (e) {
      return false;
    }
  }

  function normalize(item) {
    return {
      id: String(item.id || ''),
      handle: String(item.handle || ''),
      url: String(item.url || ''),
      image: String(item.image || ''),
      title: String(item.title || ''),
      vendor: String(item.vendor || ''),
      price: String(item.price || ''),
      comparePrice: String(item.comparePrice || ''),
      available: String(item.available || 'false') === 'true'
    };
  }

  function get() {
    return read();
  }

  function has(id) {
    id = String(id);
    return read().some(item => String(item.id) === id);
  }

  function add(item) {
    const normalized = normalize(item);
    if (!normalized.id) return false;

    let items = read();

    if (items.some(existing => String(existing.id) === normalized.id)) return true;

    items.push(normalized);
    return write(items);
  }

  function remove(id) {
    id = String(id);
    const items = read().filter(item => String(item.id) !== id);
    return write(items);
  }

  function toggle(item) {
    const id = String(item.id || '');
    if (!id) return false;

    if (has(id)) {
      return remove(id) ? false : true;
    } else {
      return add(item);
    }
  }

  function clear() {
    return write([]);
  }

  function getItemFromButton(btn) {
    return {
      id: btn.dataset.productId,
      handle: btn.dataset.productHandle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      title: btn.dataset.productTitle,
      vendor: btn.dataset.productVendor,
      price: btn.dataset.productPrice,
      comparePrice: btn.dataset.productComparePrice,
      available: btn.dataset.productAvailable
    };
  }

  function syncButtons(root) {
    const scope = root || document;
    const savedIds = new Set(read().map(item => String(item.id)));
    scope.querySelectorAll('.ks-wishlist-btn').forEach(function (btn) {
      const id = String(btn.dataset.productId || '');
      if (!id) return;
      const active = savedIds.has(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = btn.querySelector('.ks-wishlist-btn__label');
      if (label) label.textContent = active ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufügen';
      btn.setAttribute(
        'aria-label',
        active
          ? (btn.dataset.productTitle || 'Produkt') + ' aus der Wunschliste entfernen'
          : (btn.dataset.productTitle || 'Produkt') + ' zur Wunschliste hinzufügen'
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons(document);

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.ks-wishlist-btn');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const becameActive = toggle(getItemFromButton(btn));

      btn.classList.toggle('is-active', becameActive);
      btn.classList.add('is-animating');
      btn.setAttribute('aria-pressed', becameActive ? 'true' : 'false');
      const label = btn.querySelector('.ks-wishlist-btn__label');
      if (label) label.textContent = becameActive ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufügen';

      btn.setAttribute(
        'aria-label',
        becameActive
          ? (btn.dataset.productTitle || 'Produkt') + ' aus der Wunschliste entfernen'
          : (btn.dataset.productTitle || 'Produkt') + ' zur Wunschliste hinzufügen'
      );

      window.setTimeout(function () {
        btn.classList.remove('is-animating');
      }, 220);
    });

    document.addEventListener('ks:wishlist:update', function () {
      syncButtons(document);
    });
  });

  return {
    get,
    has,
    add,
    remove,
    toggle,
    clear,
    syncButtons
  };
})();
